// Quiz section
(function () {
  var ENGINE_KEY = "KesterBlackQuizEngine";

  if (window[ENGINE_KEY]) {
    window[ENGINE_KEY].initAll();
    return;
  }

  var selectors = {
    section: "[data-quiz-section]",
    root: "[data-quiz-root]",
    data: "[data-quiz-data]",
  };

  function toArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function sortByOrder(items) {
    return toArray(items)
      .slice()
      .sort(function (a, b) {
        return toNumber(a.order, 9999) - toNumber(b.order, 9999);
      });
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#096;");
  }

  function normalizeHtml(value) {
    if (value === null || value === undefined) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") {
      if (value.html) return normalizeHtml(value.html);
      if (value.value) return normalizeHtml(value.value);
    }
    return String(value);
  }

  function stripHtml(value) {
    return normalizeHtml(value).replace(/<[^>]*>/g, "").trim();
  }

  function getQuestionNavLabel(question) {
    if (question.nav_label) return question.nav_label;

    var key = String(question.question_key || "");

    if (key.indexOf("concerns") > -1) return "Nail Condition";
    if (key.indexOf("visual") > -1) return "Nail Concerns";
    if (key.indexOf("location") > -1) return "Location";
    if (key.indexOf("treatment") > -1) return "Treatment";
    if (key.indexOf("doctor") > -1 || key.indexOf("medication") > -1) {
      return "General Health";
    }
    if (key.indexOf("age") > -1) return "Lifestyle";

    return stripHtml(question.title || question.question_key);
  }

  function normalizeTags(value) {
    if (Array.isArray(value)) {
      return value.map(String).map(trimTag).filter(Boolean);
    }

    if (typeof value === "string") {
      return value
        .split(/[\n,]+/)
        .map(trimTag)
        .filter(Boolean);
    }

    return [];
  }

  function trimTag(value) {
    return String(value || "").trim();
  }

  function normalizeQuestion(question, index) {
    return {
      question_key: String(question.question_key || question.key || "").trim(),
      title: normalizeHtml(question.title || question.content || ""),
      instruction: String(question.instruction || "").trim(),
      type:
        String(question.type || "single").trim() === "multi"
          ? "multi"
          : "single",
      order: toNumber(question.order, index + 1),
      nav_label: String(question.nav_label || question.pagination_title || "").trim(),
      image: question.image || null,
      image_alt: question.image_alt || question.instruction || "",
    };
  }

  function normalizeOption(option, index) {
    var questionReference = option.question || {};
    var questionValue = questionReference.value || {};
    var questionKey =
      option.question_key ||
      questionReference.question_key ||
      questionValue.question_key ||
      "";

    return {
      label: String(option.label || ""),
      value: String(option.value || option.label || ""),
      question_key: String(questionKey).trim(),
      order: toNumber(option.order, index + 1),
      tags: normalizeTags(option.tags),
      image: option.image || null,
      image_alt: option.image_alt || option.label || "",
    };
  }

  function normalizeResult(result, index) {
    return {
      key: String(result.key || result.result_key || "").trim(),
      content: normalizeHtml(result.content || ""),
      recommendations: sortByOrder(
        toArray(result.recommendations).map(normalizeRecommendation)
      ).filter(function (recommendation) {
        return recommendation.title;
      }),
      order: toNumber(result.order, index + 1),
    };
  }

  function normalizeRecommendation(recommendation, index) {
    return {
      title: String(recommendation.title || ""),
      subtitle: String(recommendation.subtitle || ""),
      description: String(recommendation.description || ""),
      price: String(recommendation.price || ""),
      button_label: String(recommendation.button_label || "ADD TO BAG"),
      url: String(recommendation.url || ""),
      variant_id: recommendation.variant_id
        ? String(recommendation.variant_id)
        : "",
      available: recommendation.available !== false,
      tags: normalizeTags(recommendation.tags),
      image: recommendation.image || null,
      image_alt: recommendation.image_alt || recommendation.title || "",
      order: toNumber(recommendation.order, index + 1),
    };
  }

  function normalizeResultScreen(screen, index) {
    return {
      key: String(screen.key || screen.result_key || "").trim(),
      title: String(screen.title || ""),
      subtitle: String(screen.subtitle || ""),
      content: normalizeHtml(screen.content || screen.summary || ""),
      recommendations: sortByOrder(
        toArray(screen.recommendations).map(normalizeRecommendation)
      ).filter(function (recommendation) {
        return recommendation.title;
      }),
      order: toNumber(screen.order, index + 1),
    };
  }

  function readData(section) {
    var dataEl = section.querySelector(selectors.data);

    if (!dataEl) return {};

    try {
      return JSON.parse(dataEl.textContent || "{}");
    } catch (error) {
      console.warn("Quiz data could not be parsed.", error);
      return {};
    }
  }

  function createQuiz(section) {
    var root = section.querySelector(selectors.root);
    var rawData = readData(section);
    var settings = rawData.settings || {};
    var rawQuestions = toArray(rawData.questions);
    var questions = sortByOrder(
      rawQuestions.map(normalizeQuestion)
    ).filter(function (question) {
      return question.question_key;
    });
    var nestedOptions = [];
    rawQuestions.forEach(function (rawQuestion, questionIndex) {
      var normalizedQuestion = normalizeQuestion(rawQuestion, questionIndex);

      toArray(rawQuestion.options).forEach(function (option) {
        var normalizedOption = {};

        Object.keys(option || {}).forEach(function (key) {
          normalizedOption[key] = option[key];
        });

        if (!normalizedOption.question_key) {
          normalizedOption.question_key = normalizedQuestion.question_key;
        }

        nestedOptions.push(normalizedOption);
      });
    });
    var options = sortByOrder(
      toArray(rawData.options).concat(nestedOptions).map(normalizeOption)
    ).filter(function (option) {
      return option.question_key && option.value;
    });
    var results = sortByOrder(
      toArray(rawData.results).map(normalizeResult)
    ).filter(function (result) {
      return result.key && result.content;
    });
    var recommendations = sortByOrder(
      toArray(rawData.recommendations).map(normalizeRecommendation)
    ).filter(function (recommendation) {
      return recommendation.title;
    });
    var resultScreens = sortByOrder(
      toArray(rawData.resultScreens).map(normalizeResultScreen)
    ).filter(function (screen) {
      return screen.key || screen.content || screen.recommendations.length;
    });
    var state = {
      answers: {},
      tags: new Set(),
      currentStep: 0,
      started: !settings.showIntro,
      currentView: settings.showIntro ? "intro" : "question",
      history: [],
    };
    var loadingTimer = null;
    var loadingProgressTimer = null;
    var klaviyoSubmitHandler = null;
    var klaviyoLocalClickHandler = null;
    var klaviyoFallbackTimer = null;

    if (!root) return;

    function clearKlaviyoSubmitHandler() {
      if (klaviyoSubmitHandler) {
        window.removeEventListener("klaviyoForms", klaviyoSubmitHandler);
      }
      if (klaviyoLocalClickHandler) {
        root.removeEventListener("click", klaviyoLocalClickHandler);
      }
      if (klaviyoFallbackTimer) {
        window.clearTimeout(klaviyoFallbackTimer);
      }
      klaviyoSubmitHandler = null;
      klaviyoLocalClickHandler = null;
      klaviyoFallbackTimer = null;
    }

    function resetQuiz() {
      if (loadingTimer) window.clearTimeout(loadingTimer);
      if (loadingProgressTimer) window.clearInterval(loadingProgressTimer);
      clearKlaviyoSubmitHandler();
      loadingTimer = null;
      loadingProgressTimer = null;
      state.answers = {};
      state.tags = new Set();
      state.currentStep = 0;
      state.started = !settings.showIntro;
      state.currentView = state.started ? "question" : "intro";
      state.history = [];

      if (state.started) {
        renderQuestion();
      } else {
        renderIntro();
      }
    }

    function optionsForQuestion(question) {
      return options.filter(function (option) {
        return option.question_key === question.question_key;
      });
    }

    function getAnswerValues(questionKey) {
      var answer = state.answers[questionKey];
      if (Array.isArray(answer)) return answer;
      if (answer) return [answer];
      return [];
    }

    function rebuildTags() {
      state.tags = new Set();

      questions.forEach(function (question) {
        var answerValues = getAnswerValues(question.question_key);

        answerValues.forEach(function (value) {
          var selected = options.find(function (option) {
            return (
              option.question_key === question.question_key &&
              option.value === value
            );
          });

          if (!selected) return;

          selected.tags.forEach(function (tag) {
            state.tags.add(tag);
          });
        });
      });
    }

    function shouldSkip(question) {
      if (question.question_key === "q3_location") {
        var concerns = getAnswerValues("q1_concerns");

        if (
          concerns.length === 1 &&
          (concerns[0] === "general_care" || concerns[0] === "none")
        ) {
          return true;
        }
      }

      return false;
    }

    function getVisibleQuestions() {
      return questions.filter(function (question) {
        return !shouldSkip(question);
      });
    }

    function canContinue(question) {
      return getAnswerValues(question.question_key).length > 0;
    }

    function scrollToPageTop() {
      window.requestAnimationFrame(function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }

    function clearLoadingTimers() {
      if (loadingTimer) window.clearTimeout(loadingTimer);
      if (loadingProgressTimer) window.clearInterval(loadingProgressTimer);
      loadingTimer = null;
      loadingProgressTimer = null;
    }

    function bindKlaviyoSubmit(formId) {
      clearKlaviyoSubmitHandler();

      if (!formId) return;

      klaviyoSubmitHandler = function (event) {
        var detail = event.detail || {};

        if (detail.type !== "submit") return;
        if (detail.formId && String(detail.formId) !== formId) return;

        clearKlaviyoSubmitHandler();
        pushCurrentView();
        renderLoading();
        scrollToPageTop();
      };

      window.addEventListener("klaviyoForms", klaviyoSubmitHandler);

      if (!isLocalPreviewOrigin()) return;

      klaviyoLocalClickHandler = function (event) {
        if (!event.target || typeof event.target.closest !== "function") return;

        var button = event.target.closest(".klaviyo-form-button");
        if (!button || !root.contains(button)) return;

        var emailInput = root.querySelector(
          '.c-quiz__mailing-klaviyo input[type="email"]'
        );

        if (klaviyoFallbackTimer) {
          window.clearTimeout(klaviyoFallbackTimer);
        }

        klaviyoFallbackTimer = window.setTimeout(function () {
          if (emailInput && !emailInput.checkValidity()) return;

          pushCurrentView();
          renderLoading();
          scrollToPageTop();
        }, 3500);
      };

      root.addEventListener("click", klaviyoLocalClickHandler);
    }

    function isLocalPreviewOrigin() {
      return (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "::1"
      );
    }

    function pushCurrentView() {
      if (!state.currentView) return;

      var snapshot = {
        view: state.currentView,
        step: state.currentStep,
      };
      var last = state.history[state.history.length - 1];

      if (last && last.view === snapshot.view && last.step === snapshot.step) {
        return;
      }

      state.history.push(snapshot);
    }

    function restoreView(snapshot) {
      clearLoadingTimers();
      state.currentStep = snapshot.step;
      state.started = snapshot.view !== "intro";

      if (snapshot.view === "intro") {
        renderIntro();
        return;
      }

      if (snapshot.view === "mailing") {
        renderMailingList();
        return;
      }

      if (snapshot.view === "results") {
        renderResults();
        return;
      }

      renderQuestion();
    }

    function goBack() {
      var previousView = state.history.pop();

      if (previousView) {
        restoreView(previousView);
      } else {
        moveToPreviousStep();
      }

      scrollToPageTop();
    }

    function moveToNextStep() {
      var question = questions[state.currentStep];

      if (question && !canContinue(question)) {
        renderQuestion();
        return;
      }

      pushCurrentView();

      do {
        state.currentStep += 1;
      } while (
        questions[state.currentStep] &&
        shouldSkip(questions[state.currentStep])
      );

      if (state.currentStep >= questions.length) {
        state.currentStep = Math.max(questions.length - 1, 0);
        renderMailingList();
      } else {
        renderQuestion();
      }

      scrollToPageTop();
    }

    function moveToPreviousStep() {
      do {
        state.currentStep -= 1;
      } while (
        state.currentStep >= 0 &&
        shouldSkip(questions[state.currentStep])
      );

      if (state.currentStep < 0) {
        state.currentStep = 0;
        if (settings.showIntro) {
          state.started = false;
          renderIntro();
          return;
        }
      }

      renderQuestion();
    }

    function setSingleAnswer(question, value) {
      state.answers[question.question_key] = value;
      rebuildTags();
      renderQuestion();
    }

    function toggleMultiAnswer(question, value) {
      var key = question.question_key;
      var current = getAnswerValues(key);

      if (current.indexOf(value) > -1) {
        state.answers[key] = current.filter(function (item) {
          return item !== value;
        });
      } else {
        state.answers[key] = current.concat(value);
      }

      rebuildTags();
      renderQuestion();
    }

    function getResultTokens() {
      var tokens = [];

      state.tags.forEach(function (tag) {
        tokens.push(tag);
      });

      Object.keys(state.answers).forEach(function (questionKey) {
        getAnswerValues(questionKey).forEach(function (value) {
          tokens.push(value);
        });
      });

      return tokens.filter(function (token, index) {
        return token && tokens.indexOf(token) === index;
      });
    }

    function isSeriousPathway() {
      return state.tags.has("medical_flag");
    }

    function resultMatchesTokens(result, tokens) {
      var matchKeys = normalizeTags(result.key);

      if (!matchKeys.length && result.key) matchKeys = [result.key];
      if (!matchKeys.length) return false;

      return matchKeys.every(function (key) {
        return tokens.indexOf(key) > -1;
      });
    }

    function resultScreensForTokens(tokens) {
      return resultScreens.filter(function (screen) {
        return resultMatchesTokens(screen, tokens);
      });
    }

    function resultBlocksForTokens(tokens) {
      return results.filter(function (result) {
        return resultMatchesTokens(result, tokens);
      });
    }

    function recommendationsForTokens(tokens, sourceRecommendations) {
      var hasSourceRecommendations =
        Array.isArray(sourceRecommendations) && sourceRecommendations.length > 0;
      var recommendationList = hasSourceRecommendations
        ? sourceRecommendations
        : recommendations;
      var matched = recommendationList.filter(function (recommendation) {
        if (!recommendation.tags.length) return true;

        return recommendation.tags.some(function (tag) {
          return tokens.indexOf(tag) > -1;
        });
      });

      return hasSourceRecommendations ? matched : matched.slice(0, 3);
    }

    var productVariantCache = {};

    function getProductHandleFromUrl(url) {
      var productMatch = String(url || "").match(/\/products\/([^/?#]+)/);
      return productMatch ? productMatch[1] : "";
    }

    function getShopifyRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    }

    function getProductJsonUrl(url) {
      var handle = getProductHandleFromUrl(url);
      if (!handle) return "";

      return getShopifyRoot() + "products/" + handle + ".js";
    }

    function resolveVariantId(productUrl) {
      var productJsonUrl = getProductJsonUrl(productUrl);
      if (!productJsonUrl) return Promise.reject(new Error("Missing product URL."));
      if (productVariantCache[productJsonUrl]) {
        return Promise.resolve(productVariantCache[productJsonUrl]);
      }

      return fetch(productJsonUrl)
        .then(function (response) {
          if (!response.ok) throw new Error("Product could not be loaded.");
          return response.json();
        })
        .then(function (product) {
          var variants = product.variants || [];
          var variant =
            variants.find(function (item) {
              return item.available;
            }) || variants[0];

          if (!variant || !variant.id) {
            throw new Error("Product has no variant to add.");
          }

          productVariantCache[productJsonUrl] = variant.id;
          return variant.id;
        });
    }

    function addVariantToCart(variantId) {
      var cartStore =
        window.Alpine && window.Alpine.store
          ? window.Alpine.store("cart")
          : null;

      if (cartStore && typeof cartStore.addVariant === "function") {
        return cartStore.addVariant(variantId, 1);
      }

      return fetch(getShopifyRoot() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }).then(function (response) {
        if (!response.ok) throw new Error("Cart add failed.");
        window.dispatchEvent(new CustomEvent("cart:add"));
        return response.json();
      });
    }

    function bindRecommendationButtons() {
      root.querySelectorAll("[data-quiz-add-to-cart]").forEach(function (button) {
        button.addEventListener("click", function () {
          var productUrl = button.getAttribute("data-product-url");
          var variantId = button.getAttribute("data-variant-id");
          var originalLabel = button.textContent;

          button.disabled = true;
          button.textContent = "ADDING...";

          (variantId ? Promise.resolve(variantId) : resolveVariantId(productUrl))
            .then(addVariantToCart)
            .then(function () {
              button.textContent = "ADDED";
            })
            .catch(function () {
              button.textContent = "ERROR";
            })
            .finally(function () {
              window.setTimeout(function () {
                button.disabled = false;
                button.textContent = originalLabel;
              }, 1600);
            });
        });
      });
    }

    function renderProgressNav(visibleQuestions, activeIndex) {
      if (!visibleQuestions.length) return "";

      var navItems = visibleQuestions
        .map(function (question) {
          return { label: getQuestionNavLabel(question) };
        })
        .concat({ label: "Results" });

      return (
        '<ol class="c-quiz__nav" aria-label="Quiz progress">' +
        navItems
          .map(function (item, index) {
            var status = "";
            if (index < activeIndex) status = "is-complete";
            if (index === activeIndex) status = "is-active";

            return (
              '<li class="' +
              status +
              '"' +
              (index === activeIndex ? ' aria-current="step"' : "") +
              ">" +
              '<span class="c-quiz__nav-icon" aria-hidden="true"></span>' +
              '<span class="c-quiz__nav-number" aria-hidden="true">' +
              (index + 1) +
              "</span>" +
              '<span class="c-quiz__nav-label">' +
              escapeHtml(item.label) +
              "</span>" +
              '<span class="visually-hidden">Step ' +
              (index + 1) +
              "</span>" +
              "</li>"
            );
          })
          .join("") +
        "</ol>"
      );
    }

    function renderQuizHeader(activeLabel, activeIndexOverride) {
      var visibleQuestions = getVisibleQuestions();
      var activeIndex =
        typeof activeIndexOverride === "number"
          ? activeIndexOverride
          : visibleQuestions.length;

      return (
        '<div class="c-quiz__step-header">' +
        '<div class="c-quiz__step-titlebar">' +
        '<h2 class="c-quiz__step-title o-heading--3">' +
        escapeHtml(settings.eyebrow || "Nail Care Quiz") +
        "</h2>" +
        '<button type="button" class="c-quiz__restart o-btn is-large" data-quiz-restart-current>' +
        escapeHtml(settings.restartButtonLabel || "RESTART QUIZ") +
        "</button>" +
        "</div>" +
        '<div class="c-quiz__step-meta">' +
        '<p class="c-quiz__progress-label o-subtitle">' +
        escapeHtml(activeLabel || "") +
        "</p>" +
        renderProgressNav(visibleQuestions, activeIndex) +
        "</div>" +
        "</div>"
      );
    }

    function renderIntro() {
      state.currentView = "intro";

      var heading =
        settings.heading || "Find the perfect solution for your nails";
      var eyebrow = settings.eyebrow || "Nail Care Quiz";
      var intro = normalizeHtml(settings.intro);
      var media = settings.heroImage
        ? '<div class="c-quiz__intro-media"><img src="' +
          escapeAttribute(settings.heroImage) +
          '" alt="' +
          escapeAttribute(settings.heroImageAlt || heading) +
          '"></div>'
        : '<div class="c-quiz__intro-media c-quiz__intro-media--placeholder" aria-hidden="true"><span></span></div>';

      root.innerHTML =
        '<div class="c-quiz__intro">' +
        '<div class="c-quiz__intro-content">' +
        '<p class="c-quiz__eyebrow o-subtitle">' +
        escapeHtml(eyebrow) +
        "</p>" +
        '<h2 class="c-quiz__intro-heading o-heading--1">' +
        escapeHtml(heading) +
        "</h2>" +
        (intro ? '<div class="c-quiz__intro-copy o-rte">' + intro + "</div>" : "") +
        '<button type="button" class="c-quiz__button o-btn is-large" data-quiz-start>' +
        escapeHtml(settings.startButtonLabel || "TAKE THE QUIZ") +
        "</button>" +
        "</div>" +
        media +
        "</div>";

      root
        .querySelector("[data-quiz-start]")
        .addEventListener("click", function () {
          pushCurrentView();
          state.started = true;
          renderQuestion();
          scrollToPageTop();
        });
    }

    function renderEmpty() {
      root.innerHTML =
        '<div class="c-quiz__empty">' +
        '<p class="c-quiz__eyebrow o-subtitle">' +
        escapeHtml(settings.eyebrow || "Nail Care Quiz") +
        "</p>" +
        '<h2 class="c-quiz__empty-heading o-heading--1">' +
        escapeHtml(
          settings.emptyStateHeading || "Quiz content is not set up yet"
        ) +
        "</h2>" +
        '<div class="c-quiz__empty-copy o-rte">' +
        normalizeHtml(settings.emptyStateText || "") +
        "</div>" +
        "</div>";
    }

    function renderQuestion() {
      state.currentView = "question";

      var question = questions[state.currentStep];

      if (!question) {
        renderEmpty();
        return;
      }

      if (shouldSkip(question)) {
        moveToNextStep();
        return;
      }

      var visibleQuestions = getVisibleQuestions();
      var visibleIndex = visibleQuestions.findIndex(function (item) {
        return item.question_key === question.question_key;
      });
      var stepLabel =
        "Question " + (visibleIndex + 1) + " of " + visibleQuestions.length;
      var questionOptions = optionsForQuestion(question);
      var selectedValues = getAnswerValues(question.question_key);
      var hasMedia = questionOptions.some(function (option) {
        return option.image;
      });
      var questionTitle =
        question.title || "<p>" + escapeHtml(question.question_key) + "</p>";
      var questionInstruction = question.instruction
        ? '<p class="c-quiz__instruction o-subtitle">' +
          escapeHtml(question.instruction) +
          "</p>"
        : "";
      var questionMedia = question.image
        ? '<figure class="c-quiz__question-media"><img src="' +
          escapeAttribute(question.image) +
          '" alt="' +
          escapeAttribute(question.image_alt || "") +
          '"></figure>'
        : "";
      var optionsHtml = questionOptions.length
        ? questionOptions
            .map(function (option) {
              var selected = selectedValues.indexOf(option.value) > -1;
              var media = option.image
                ? '<span class="c-quiz__option-media"><img src="' +
                  escapeAttribute(option.image) +
                  '" alt="' +
                  escapeAttribute(option.image_alt || option.label) +
                  '"></span>'
                : "";

              return (
                '<button type="button" class="c-quiz__option ' +
                (question.type === "single" ? "c-quiz__option--single " : "") +
                (selected ? "is-selected" : "") +
                '" data-quiz-option data-value="' +
                escapeAttribute(option.value) +
                '" aria-pressed="' +
                (selected ? "true" : "false") +
                '" role="listitem">' +
                media +
                '<span class="c-quiz__option-label o-type--1">' +
                escapeHtml(option.label) +
                "</span>" +
                "</button>"
              );
            })
            .join("")
        : '<p class="c-quiz__option-empty o-subtitle">No options have been added for this question.</p>';

      root.innerHTML =
        '<div class="c-quiz__step">' +
        '<div class="c-quiz__step-header">' +
        '<div class="c-quiz__step-titlebar">' +
        '<h2 class="c-quiz__step-title o-heading--3">' +
        escapeHtml(settings.eyebrow || "Nail Care Quiz") +
        "</h2>" +
        '<button type="button" class="c-quiz__restart o-btn is-large" data-quiz-restart-current>' +
        escapeHtml(settings.restartButtonLabel || "RESTART QUIZ") +
        "</button>" +
        "</div>" +
        '<div class="c-quiz__step-meta">' +
        '<p class="c-quiz__progress-label o-subtitle">' +
        escapeHtml(stepLabel) +
        "</p>" +
        renderProgressNav(visibleQuestions, visibleIndex) +
        "</div>" +
        "</div>" +
        '<div class="c-quiz__question-layout ' +
        (questionMedia ? "has-media" : "") +
        '">' +
        '<div class="c-quiz__question-main">' +
        '<div class="c-quiz__question o-heading--3" tabindex="-1" data-quiz-heading>' +
        questionTitle +
        "</div>" +
        questionInstruction +
        '<div class="c-quiz__options ' +
        (hasMedia ? "c-quiz__options--cards" : "") +
        (question.type === "single" && !hasMedia
          ? " c-quiz__options--buttons"
          : "") +
        '" role="list">' +
        optionsHtml +
        "</div>" +
        "</div>" +
        questionMedia +
        "</div>" +
        '<div class="c-quiz__actions">' +
        '<button type="button" class="c-quiz__button c-quiz__button--secondary o-btn is-large" data-quiz-back>' +
        escapeHtml(settings.backButtonLabel || "BACK") +
        "</button>" +
        '<button type="button" class="c-quiz__button o-btn is-large" data-quiz-next ' +
        (canContinue(question) ? "" : "disabled") +
        ">" +
        escapeHtml(settings.nextButtonLabel || "NEXT") +
        "</button>" +
        "</div>" +
        "</div>";

      root.querySelectorAll("[data-quiz-option]").forEach(function (button) {
        button.addEventListener("click", function () {
          var value = button.getAttribute("data-value");

          if (question.type === "multi") {
            toggleMultiAnswer(question, value);
          } else {
            setSingleAnswer(question, value);
          }
        });
      });

      root
        .querySelector("[data-quiz-back]")
        .addEventListener("click", goBack);

      root
        .querySelector("[data-quiz-next]")
        .addEventListener("click", moveToNextStep);

      root
        .querySelector("[data-quiz-restart-current]")
        .addEventListener("click", resetQuiz);

      var heading = root.querySelector("[data-quiz-heading]");
      if (heading) heading.focus({ preventScroll: true });
    }

    function renderRecommendations(tokens, sourceRecommendations) {
      var matched = recommendationsForTokens(tokens, sourceRecommendations);

      if (!matched.length) return "";

      return (
        '<section class="c-quiz__recommendations" aria-label="Recommended products">' +
        '<div class="c-quiz__recommendation-grid">' +
        matched
          .map(function (recommendation) {
            var media = recommendation.image
              ? '<img src="' +
                escapeAttribute(recommendation.image) +
                '" alt="' +
                escapeAttribute(
                  recommendation.image_alt || recommendation.title
                ) +
                '">'
              : '<span aria-hidden="true"></span>';
            var action =
              recommendation.url && recommendation.available
                ? '<button class="c-quiz__recommendation-button o-btn is-full-width" type="button" data-quiz-add-to-cart data-product-url="' +
                escapeAttribute(recommendation.url) +
                '" data-variant-id="' +
                escapeAttribute(recommendation.variant_id) +
                '">' +
                escapeHtml(recommendation.button_label || "SHOP NOW") +
                (recommendation.price
                  ? " - " + escapeHtml(recommendation.price)
                  : "") +
                "</button>"
                : '<button class="c-quiz__recommendation-button o-btn is-full-width" type="button" disabled>' +
                escapeHtml(
                  recommendation.available === false ? "SOLD OUT" : "ADD TO BAG"
                ) +
                (recommendation.price
                  ? " - " + escapeHtml(recommendation.price)
                  : "") +
                "</button>";

            return (
              '<article class="c-quiz__recommendation">' +
              '<div class="c-quiz__recommendation-media">' +
              media +
              "</div>" +
              '<div class="c-quiz__recommendation-content">' +
              (recommendation.subtitle
                ? '<p class="c-quiz__recommendation-subtitle o-subtitle--2">' +
                  escapeHtml(recommendation.subtitle) +
                  "</p>"
                : "") +
              '<h3 class="c-quiz__recommendation-title o-heading--3">' +
              escapeHtml(recommendation.title) +
              "</h3>" +
              (recommendation.description
                ? '<p class="c-quiz__recommendation-description o-type--2">' +
                  escapeHtml(recommendation.description) +
                  "</p>"
                : "") +
              action +
              "</div>" +
              "</article>"
            );
          })
          .join("") +
        "</div>" +
        "</section>"
      );
    }

    function renderMailingList() {
      state.currentView = "mailing";

      var heading =
        settings.mailingHeading || "Want your free personalised nail care guide?";
      var copy =
        settings.mailingCopy ||
        "Join our list and we’ll send it straight to your inbox – along with expert tips, product recommendations, and early access to special offers.";
      var emailLabel = settings.mailingEmailLabel || "EMAIL ADDRESS";
      var klaviyoFormId = String(
        settings.mailingKlaviyoFormId || "SE93G7"
      ).trim();
      var mailingForm = klaviyoFormId
        ? '<div class="c-quiz__mailing-klaviyo"><div class="klaviyo-form-' +
          escapeAttribute(klaviyoFormId) +
          '"></div></div>'
        : '<form class="c-quiz__mailing-form" data-quiz-mailing-form>' +
          '<label class="c-quiz__mailing-label o-subtitle" for="quiz-email-' +
          escapeAttribute(section.id || "section") +
          '">' +
          escapeHtml(emailLabel) +
          "</label>" +
          '<input id="quiz-email-' +
          escapeAttribute(section.id || "section") +
          '" class="c-quiz__mailing-input" type="email" autocomplete="email">' +
          '<button class="c-quiz__mailing-submit o-btn is-large" type="submit">' +
          escapeHtml(settings.mailingSubmitLabel || "SUBMIT") +
          "</button>" +
          "</form>";

      root.innerHTML =
        '<div class="c-quiz__mailing">' +
        renderQuizHeader("Results") +
        '<div class="c-quiz__mailing-content">' +
        '<h2 class="c-quiz__mailing-heading o-heading--3">' +
        escapeHtml(heading) +
        "</h2>" +
        '<p class="c-quiz__mailing-copy">' +
        escapeHtml(copy) +
        "</p>" +
        mailingForm +
        '<button class="c-quiz__mailing-skip o-btn is-large" type="button" data-quiz-skip-mailing>' +
        escapeHtml(
          settings.mailingSkipLabel || "NO THANKS, TAKE ME TO MY RESULTS"
        ) +
        "</button>" +
        '<button class="c-quiz__mailing-back c-quiz__button c-quiz__button--secondary o-btn is-large" type="button" data-quiz-mailing-back>' +
        escapeHtml(settings.backButtonLabel || "BACK") +
        "</button>" +
        "</div>" +
        "</div>";

      bindKlaviyoSubmit(klaviyoFormId);

      var form = root.querySelector("[data-quiz-mailing-form]");
      if (form) {
        form.addEventListener("submit", function (event) {
          event.preventDefault();
          clearKlaviyoSubmitHandler();
          pushCurrentView();
          renderLoading();
          scrollToPageTop();
        });
      }

      root
        .querySelector("[data-quiz-skip-mailing]")
        .addEventListener("click", function () {
          clearKlaviyoSubmitHandler();
          pushCurrentView();
          renderLoading();
          scrollToPageTop();
        });

      root
        .querySelector("[data-quiz-mailing-back]")
        .addEventListener("click", function () {
          clearKlaviyoSubmitHandler();
          goBack();
        });

      root
        .querySelector("[data-quiz-restart-current]")
        .addEventListener("click", resetQuiz);
    }

    function renderLoading() {
      state.currentView = "loading";
      clearKlaviyoSubmitHandler();
      clearLoadingTimers();
      var duration = 2200;
      var startedAt = Date.now();

      root.innerHTML =
        '<div class="c-quiz__loading">' +
        renderQuizHeader("Results") +
        '<div class="c-quiz__loading-content" aria-live="polite" aria-busy="true">' +
        '<p class="c-quiz__loading-percent o-heading--1" data-quiz-loading-percent>0%</p>' +
        '<p class="c-quiz__loading-label o-subtitle">CALCULATING YOUR RESULTS...</p>' +
        "</div>" +
        "</div>";

      root
        .querySelector("[data-quiz-restart-current]")
        .addEventListener("click", resetQuiz);

      loadingProgressTimer = window.setInterval(function () {
        var percent = Math.min(
          100,
          Math.round(((Date.now() - startedAt) / duration) * 100)
        );
        var percentEl = root.querySelector("[data-quiz-loading-percent]");
        if (percentEl) percentEl.textContent = percent + "%";
      }, 80);

      loadingTimer = window.setTimeout(function () {
        if (loadingProgressTimer) window.clearInterval(loadingProgressTimer);
        loadingTimer = null;
        loadingProgressTimer = null;
        renderResults();
      }, duration);
    }

    function renderSeriousResults() {
      state.currentView = "results";
      var copy =
        normalizeHtml(settings.seriousResultsCopy) ||
        "<p>Serious nail conditions can be signs of broader health issues that topical products won’t be able to help with.</p><p>Please check in with your GP if you have any concerns.</p>";
      var media = settings.seriousResultsImage
        ? '<div class="c-quiz__gp-media"><img src="' +
          escapeAttribute(settings.seriousResultsImage) +
          '" alt="' +
          escapeAttribute(
            settings.seriousResultsImageAlt ||
              settings.seriousResultsHeading ||
              ""
          ) +
          '"></div>'
        : '<div class="c-quiz__gp-media" aria-hidden="true"><span></span></div>';

      root.innerHTML =
        '<div class="c-quiz__gp-results">' +
        renderQuizHeader("Results") +
        media +
        '<div class="c-quiz__gp-content">' +
        '<p class="c-quiz__results-heading o-heading--1">' +
        escapeHtml(settings.seriousResultsKicker || "Results") +
        "</p>" +
        '<h2 class="c-quiz__gp-heading o-heading--1">' +
        escapeHtml(settings.seriousResultsHeading || "Please speak to your GP") +
        "</h2>" +
        '<div class="c-quiz__gp-copy o-rte">' +
        copy +
        "</div>" +
        '<button class="c-quiz__button c-quiz__button--secondary o-btn is-large" type="button" data-quiz-results-back>' +
        escapeHtml(settings.backButtonLabel || "BACK") +
        "</button>" +
        "</div>" +
        "</div>";

      root
        .querySelector("[data-quiz-results-back]")
        .addEventListener("click", goBack);

      root
        .querySelector("[data-quiz-restart-current]")
        .addEventListener("click", resetQuiz);

      bindRecommendationButtons();
    }

    function renderResults() {
      if (isSeriousPathway()) {
        renderSeriousResults();
        return;
      }

      state.currentView = "results";

      var tokens = getResultTokens();
      var matchedScreens = resultScreensForTokens(tokens);
      var resultScreen = matchedScreens[0];
      var blocks = resultScreen ? [resultScreen] : resultBlocksForTokens(tokens);
      var resultRecommendations = resultScreen
        ? resultScreen.recommendations
        : blocks.reduce(function (items, block) {
            return items.concat(toArray(block.recommendations));
          }, []);
      var firstBlock = blocks[0];
      var resultsHtml = blocks.length
        ? blocks
            .map(function (block) {
              return (
                '<article class="c-quiz__result-block o-rte">' +
                block.content +
                "</article>"
              );
            })
            .join("")
        : '<article class="c-quiz__result-block o-rte"><p>Your answers have been saved, but no result blocks are configured yet.</p></article>';

      root.innerHTML =
        '<div class="c-quiz__results">' +
        renderQuizHeader("Results") +
        '<div class="c-quiz__results-header">' +
        '<h2 class="c-quiz__results-heading o-heading--1">' +
        escapeHtml(settings.resultsHeading || "Results") +
        "</h2>" +
        '<h3 class="c-quiz__results-subheading o-heading--1">Based on your answers,<br>we suggest these products.</h3>' +
        (firstBlock
          ? '<article class="c-quiz__results-summary o-rte">' +
            firstBlock.content +
            "</article>"
          : "") +
        "</div>" +
        '<div class="c-quiz__result-list">' +
        resultsHtml +
        "</div>" +
        renderRecommendations(tokens, resultRecommendations) +
        '<div class="c-quiz__actions">' +
        '<button type="button" class="c-quiz__button c-quiz__button--secondary o-btn is-large" data-quiz-results-back>' +
        escapeHtml(settings.backButtonLabel || "BACK") +
        "</button>" +
        "</div>" +
        "</div>";

      root
        .querySelector("[data-quiz-results-back]")
        .addEventListener("click", goBack);

      root
        .querySelector("[data-quiz-restart-current]")
        .addEventListener("click", resetQuiz);

      bindRecommendationButtons();
    }

    if (!questions.length) {
      renderEmpty();
      return;
    }

    if (state.started) {
      renderQuestion();
    } else {
      renderIntro();
    }
  }

  function initSection(section) {
    if (!section || section.dataset.quizInitialized === "true") return;

    section.dataset.quizInitialized = "true";
    createQuiz(section);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll(selectors.section).forEach(initSection);
  }

  window[ENGINE_KEY] = {
    initAll: initAll,
    initSection: initSection,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
